import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"

export default function Products() {
    const {
        response: { products },
        loading
    } = useAppState()

    console.log('products.jsx, products', products)

    return (
        products.hits.map((hit, index) => (
            <div class='plp-grid--listitem-wrapper'>
                <div class='plp-grid--listitem-inner'>
                    <li class='scroll-trigger animate--slide-in plp-list__item-new'>
                        <Product product={hit} key={hit.productId || index} />
                    </li>
                </div>
            </div>
        ))
    )
}
